<template>
  <div
    class="split-button field has-addons"
    :class="[
      triggerSide === 'left' ? 'is-trigger-left' : 'is-trigger-right',
      { 'is-ghost': ghost },
    ]"
  >
    <p class="control is-expanded">
      <slot name="action">
        <BBtn
          :label="label"
          :icon="icon"
          :variant="effectiveVariant"
          :size="size"
          :outlined="outlined"
          :compact="compact"
          :loading="loading"
          :disabled="disabled"
          :tooltip="tooltip"
          @click="$emit('click', $event)"
        />
      </slot>
    </p>
    <p class="control">
      <DropdownButton
        :variant="effectiveVariant"
        :size="size"
        :outlined="outlined"
        :disabled="disabled || loading"
        :loading="loading"
        :align="align"
      >
        <slot />
      </DropdownButton>
    </p>
  </div>
</template>

<script>
import BBtn from './BaseButton.vue'
import DropdownButton from './DropdownButton.vue'

export default {
  name: 'SplitButton',
  components: { BBtn, DropdownButton },
  props: {
    label: { type: String, default: '' },
    icon: { type: [String, Array], default: null },
    variant: { type: String, default: 'primary' },
    size: { type: String, default: 'small' },
    outlined: { type: Boolean, default: true },
    compact: { type: String, default: 'auto' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tooltip: { type: [String, Object], default: null },
    ghost: { type: Boolean, default: false },
    align: { type: String, default: 'start' },
    triggerSide: {
      type: String,
      default: 'right',
      validator: (v) => ['left', 'right'].includes(v),
    },
  },
  emits: ['click'],
  computed: {
    effectiveVariant() {
      return this.ghost ? 'ghost' : this.variant
    },
  },
}
</script>

<style lang="scss" scoped>
.split-button {
  display: inline-flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 0;
  }
}

.is-trigger-left {
  flex-direction: row-reverse;
}

// Remove inner border-radius for seamless join
.is-trigger-right .control:first-child :deep(.button) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.is-trigger-right .control:last-child :deep(.button) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.is-trigger-left .control:first-child :deep(.button) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.is-trigger-left .control:last-child :deep(.button) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

// Ghost variant: compact, borderless, icon-button-like
.is-ghost {
  :deep(.button) {
    border-color: transparent;
    background: none;
    box-shadow: none;
    padding: 0.15em 0.35em;
    height: auto;

    &:hover,
    &:focus-visible {
      background: var(--scheme-main-bis, hsl(0, 0%, 96%));
    }
  }

  // Remove dotted label underline from ghost BaseButton
  :deep(.btn__label) {
    border-bottom: none;
  }
}
</style>
